import React, { useState, useEffect } from 'react';
import { GoogleLogin } from 'react-google-login';
import './App.css';



const App = () => {
  const [data, setData] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const clientId = "1086660881248-ldrfmj7dpi55iev5qtqjiitem418b093.apps.googleusercontent.com";
  
  useEffect(() => {
    fetchData();
  }, []);

  const onSuccess = (res) => {
    console.log("LOGIN SUCCESS! Current user : ", res.profileObj);
    setIsLoggedIn(true);
  }

  const onFailure = (res) => {
      console.log("LOGIN FALIED! res: ", res);
  }

  const handleLogin = async() => {
    console.log("OK");
    try {
      const response = await fetch('https://dtv-air-reporting.test.directvadtech.com:8443/auth', {
        method:'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        credentials: 'include'
      });
      if (response.ok) {
        console.log("Response from the server:", response);
        setIsLoggedIn(true);
      } else {
        console.error('Failed to authenticate');
      }
    } catch (error) {
      console.log("Error:", error);
    } 
    
  }
  const fetchData = async () => {
    try {
      const response = await fetch('https://dtv-air-reporting.test.directvadtech.com:8443/api/test'); // Specify the full URL including the port
      if (!response.ok) {
        throw new Error('Failed to fetch data');
      }
      const jsonData = await response.json();
      setData(jsonData.message);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  return (
    <div className="App">
      <header className="App-header">
        <h1>AIR ARS Reporting</h1>
        <p>{data}</p>
        <button onClick={handleLogin}>Login</button>
        <a href="https://dtv-air-reporting.test.directvadtech.com:8443/auth">Login with Google</a>
      </header>
    </div>
  );
}

export default App;